import { useCallback, useMemo } from 'react';

import { useFormContext } from 'core/states';
import {
  IProjectFormFieldProps,
  ProjectFormField as BaseProjectFormField,
} from 'projects/components';
import { IProjectAutocomplete } from 'projects/types';

export const ProjectFormField = (props: IProjectFormFieldProps) => {
  const { setValue, watch } = useFormContext();

  const billToLocation = watch('billToLocation');
  const shipToLocation = watch('shipToLocation');

  const onChangeProject = useCallback(
    (project: IProjectAutocomplete) => {
      if (!project || !project.verticalMarketId) {
        return;
      }

      setValue('verticalMarket', {
        id: project.verticalMarketId,
        name: project.verticalMarketName,
      });
    },
    [setValue]
  );

  const requestPayload = useMemo(() => {
    const billToAccountNumber = billToLocation?.accountsReceivableId;
    const shipToAccountNumber = shipToLocation?.accountsReceivableId;
    const hasAccountNumberFilters = Boolean(billToAccountNumber || shipToAccountNumber);

    if (!hasAccountNumberFilters) {
      return {};
    }

    return {
      filters: {
        accountNumbers: {
          billTo: billToAccountNumber || '',
          shipTo: shipToAccountNumber || '',
        },
      },
    };
  }, [billToLocation?.accountsReceivableId, shipToLocation?.accountsReceivableId]);

  return (
    // enabledOnFocus={false} pre-loads Project options when Bill To changes
    <BaseProjectFormField
      {...props}
      requestPayload={requestPayload}
      onChange={onChangeProject}
      enabledOnFocus={false}
    />
  );
};
